export const RECEIPT_FIELD_META = [
  { key: 'orderNo', labelZh: '订单号', inputType: 'text' },
  { key: 'pickup', labelZh: '取货方式', inputType: 'text' },
  { key: 'orderAccount', labelZh: '下单账号', inputType: 'text' },
  { key: 'printTime', labelZh: '打印时间', inputType: 'text' },
  { key: 'userName', labelZh: '收货人', inputType: 'text' },
  { key: 'userPhone', labelZh: '联系方式', inputType: 'text' },
  { key: 'items', labelZh: '品名明细', inputType: 'textarea' },
  { key: 'totalPrice', labelZh: '总价', inputType: 'text' },
  { key: 'paymentMethod', labelZh: '支付方式', inputType: 'text' },
  { key: 'currentMeal', labelZh: '当前餐次', inputType: 'text' },
  { key: 'packageName', labelZh: '套餐类型', inputType: 'text' },
  { key: 'packageQty', labelZh: '套餐数量', inputType: 'number' },
  { key: 'remainingMeals', labelZh: '剩余餐次', inputType: 'text' },
  { key: 'consigneeName', labelZh: '收货人', inputType: 'text' },
  { key: 'address', labelZh: '配送地址', inputType: 'textarea' },
  { key: 'deliveryRegion', labelZh: '配送区域', inputType: 'text' },
  { key: 'remark', labelZh: '备注', inputType: 'textarea' },
  { key: 'riderName', labelZh: '骑手名字', inputType: 'text' },
  { key: 'riderPhone', labelZh: '骑手联系方式', inputType: 'text' },
  { key: 'storePhone', labelZh: '店铺电话', inputType: 'readonly' },
  { key: 'storeAddress', labelZh: '店铺地址', inputType: 'readonly' },
  { key: 'serviceQr', labelZh: '店铺客服二维码', inputType: 'readonly' },
  { key: 'miniProgramQr', labelZh: '点餐小程序码', inputType: 'readonly' }
]

/** 飞鹅云零售小票字段（无 Logo/二维码） */
export const FEIE_FIELD_META = [
  { key: 'orderNo', labelZh: '订单号', inputType: 'text' },
  { key: 'pickupCode', labelZh: '取餐码', inputType: 'text' },
  { key: 'pickup', labelZh: '取货方式', inputType: 'text' },
  { key: 'diningType', labelZh: '就餐方式', inputType: 'text' },
  { key: 'printTime', labelZh: '打印时间', inputType: 'text' },
  { key: 'userName', labelZh: '顾客姓名', inputType: 'text' },
  { key: 'userPhone', labelZh: '电话', inputType: 'text' },
  { key: 'items', labelZh: '品名明细', inputType: 'textarea' },
  { key: 'packageName', labelZh: '品名', inputType: 'text' },
  { key: 'packageQty', labelZh: '数量', inputType: 'number' },
  { key: 'totalPrice', labelZh: '合计', inputType: 'text' },
  { key: 'paymentMethod', labelZh: '支付方式', inputType: 'text' },
  { key: 'address', labelZh: '地址', inputType: 'textarea' },
  { key: 'deliveryRegion', labelZh: '区域', inputType: 'text' },
  { key: 'remark', labelZh: '备注', inputType: 'textarea' },
  { key: 'source', labelZh: '来源', inputType: 'text' },
  { key: 'storePhone', labelZh: '店铺电话', inputType: 'readonly' },
  { key: 'storeAddress', labelZh: '店铺地址', inputType: 'readonly' }
]

export const RECEIPT_PRINT_BUILTIN_DEFAULTS = {
  orderNo: 'ERP系统-自定义订单',
  pickup: '自取/同城配送',
  orderAccount: 'ERP系统',
  paymentMethod: '支付方式请联系客服查询',
  packageName: '套餐类型请联系客服查询',
  packageQty: 1
}

export const FEIE_PRINT_BUILTIN_DEFAULTS = {
  orderNo: '零售单-自定义',
  pickup: '到店自取',
  diningType: '外带',
  paymentMethod: '微信支付',
  packageName: '超级碗',
  packageQty: 1,
  totalPrice: '39.80',
  source: '自定义打印'
}

/** 映美云打印表单可填字段 */
export const RECEIPT_PRINT_FIELD_KEYS = RECEIPT_FIELD_META.filter(
  (f) => !['storePhone', 'storeAddress', 'serviceQr', 'miniProgramQr', 'userName'].includes(f.key)
).map((f) => f.key)

/** 飞鹅云打印表单可填字段 */
export const FEIE_PRINT_FIELD_KEYS = FEIE_FIELD_META.filter(
  (f) => !['storePhone', 'storeAddress'].includes(f.key)
).map((f) => f.key)

export function defaultReceiptFieldValues() {
  const values = {}
  for (const f of RECEIPT_FIELD_META) {
    values[f.key] = ''
  }
  for (const f of FEIE_FIELD_META) {
    if (values[f.key] === undefined) values[f.key] = ''
  }
  return values
}

import { formatDateTime } from '../utils/dateTimeUtils'

export function formatChinaDateTime(date = new Date()) {
  return formatDateTime(date)
}
